import styled from "styled-components";
import pop from "../../assets/pop.png";

// Style commun pour les bordures avec dégradé
const gradientBorderStyle = `
  background: linear-gradient(107.79deg, rgba(150, 150, 150, 0.31) 4.56%, rgba(22, 22, 69, 0.31) 82.64%);
  
  border-image-source: linear-gradient(86.25deg, rgba(255, 254, 254, 0.38) 25.58%, #161645 127%, rgba(255, 255, 255, 0) 127.01%);
  border-image-slice: 1;
  border-radius: 0.75vw;
`;

export const ValuesSectionWrapper = styled.div`
  width: 100%;
  background: transparent;
  overflow: hidden;
  position: relative;
  font-family: Raleway;
  
  /* Approche avec margin negative */
  margin-top: -28vw; 
  z-index: 2;
`;

export const ValuesContainer = styled.div`
  max-width: 89vw;
  width: 100%;
  margin: 0 auto;
  background: #161645;
  border-radius: 1.5vw 1.5vw 0 0;
  padding: 3vw;
  display: flex;
  gap: 11vw;
  align-items: flex-start;
  font-family: Raleway;

  @media (max-width: 768px) {
    max-width: 92vw;
    flex-direction: column;
    gap: 10vw;
    padding: 6vw;
    border-radius: 3vw 3vw 0 0;
  }
`;

// Nouveaux composants avec les classes CSS appliquées
export const ContentImgLeft = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const ContentDetailsRight = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const LeftSection = styled.div`
  flex: 0 0 25vw;
  position: relative;
  height: 31vw;
  font-family: Raleway;

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    height: 80vw;
    display: flex;
    justify-content: center;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 21.75vw;
  height: 26.75vw;
  font-family: Raleway;

  @media (max-width: 768px) {
    width: 50vw;
    height: 63.33vw;
  }
`;

export const MainImageBg = styled.div`
  width: 100%;
  height: 100%;
  background: #ff4d1a;
  border-radius: 1.25vw;
  overflow: hidden;
  position: relative;
  font-family: Raleway;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    border-radius: 3.33vw;
  }
`;

// BadgeAventure avec le nouveau style de bordure
export const BadgeAventure = styled.div`
  position: absolute;
  top: 1.25vw;
  right: -9.125vw;
  ${gradientBorderStyle}
  color: white;
  padding: 0.9375vw 1.125vw;
  font-size: 0.8125vw;
  font-weight: 200;
  letter-spacing: 0.03vw;
  z-index: 9;
  white-space: nowrap;
  font-family: Raleway;

  @media (max-width: 768px) {
    top: 3.33vw;
    right: -8.33vw;
    padding: 2.5vw 3vw;
    font-size: 2.17vw;
    border-radius: 2vw;
  }
`;

export const OrangeIcon = styled.div`
  position: absolute;
  top: 0.3125vw;
  right: -11vw;
  width: 3.125vw;
  height: 3.125vw;
  background: #ff4d1a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0.25vw 0.9375vw rgba(255, 77, 26, 0.4);
  z-index: 10;
  font-family: Raleway;

  svg {
    width: 1.75vw;
    height: 1.75vw;
  }

  @media (max-width: 768px) {
    top: 0.83vw;
    right: -13.33vw;
    width: 8.33vw;
    height: 8.33vw;

    svg {
      width: 4.67vw;
      height: 4.67vw;
    }
  }
`;

// SupportCard avec le nouveau style de bordure
export const SupportCard = styled.div`
  position: absolute;
  top: 10.375vw;
  left: -4.375vw;
  ${gradientBorderStyle}
  padding: 0.9375vw 1.125vw;
  width: 13.125vw;
  z-index: 9;
  font-family: Raleway;

  @media (max-width: 768px) {
    top: 38.33vw;
    left: -11.67vw;
    width: 35vw;
    padding: 2.5vw 3vw;
    border-radius: 2vw;
  }
`;

export const SupportTitle = styled.h4`
  color: white;
  font-size: 0.8125vw;
  font-weight: 200;
  margin-bottom: 0.375vw;
  letter-spacing: 0.03vw;
  font-family: Raleway;

  @media (max-width: 768px) {
    font-size: 2.17vw;
    margin-bottom: 1vw;
  }
`;

export const SupportText = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.625vw;
  line-height: 1.5;
  font-family: Raleway;

  @media (max-width: 768px) {
    font-size: 1.67vw;
  }
`;

export const WhatsAppIconWrapper = styled.div`
  position: absolute;
  top: 9.4375vw;
  left: 6.5625vw;
  width: 3.125vw;
  height: 3.125vw;
  background: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0.25vw 0.9375vw rgba(37, 211, 102, 0.4);
  z-index: 10;
  font-family: Raleway;

  svg {
    width: 1.75vw;
    height: 1.75vw;
  }

  @media (max-width: 768px) {
    top: 35.83vw;
    left: 17.5vw;
    width: 8.33vw;
    height: 8.33vw;

    svg {
      width: 4.67vw;
      height: 4.67vw;
    }
  }
`;

// AuthorCard avec le nouveau style de bordure
export const AuthorCard = styled.div`
  position: absolute;
  bottom: -1.5625vw;
  left: 50%;
  transform: translateX(-50%);
  ${gradientBorderStyle}
  padding: 0.75vw 1vw;
  display: flex;
  align-items: center;
  gap: 0.75vw;
  z-index: 10;
  min-width: 17.5vw;
  font-family: Raleway;

  @media (max-width: 768px) {
    bottom: -4.17vw;
    min-width: 46.67vw;
    padding: 2vw 2.67vw;
    gap: 2vw;
    border-radius: 2vw;
  }
`;

export const AuthorAvatar = styled.div`
  width: 2.625vw;
  height: 2.625vw;
  border-radius: 0.625vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.375vw;
  font-family: Raleway;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 7vw;
    height: 7vw;
    font-size: 3.67vw;
    border-radius: 1.67vw;
  }
`;

export const AuthorInfo = styled.div`
  flex: 1;
  font-family: Raleway;
`;

export const AuthorName = styled.h5`
  color: white;
  font-size: 0.8125vw;
  font-weight: 200;
  margin-bottom: 0.1875vw;
  font-family: Raleway;

  @media (max-width: 768px) {
    font-size: 2.17vw;
    margin-bottom: 0.5vw;
  }
`;

export const AuthorRole = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.6875vw;
  font-family: Raleway;

  @media (max-width: 768px) {
    font-size: 1.83vw;
  }
`;

export const ViewButton = styled.button`
  background: linear-gradient(135deg, #ff8a00, #ff4d1a);
  color: white;
  border: none;
  padding: 0.5vw 1.125vw;
  border-radius: 0.375vw;
  font-size: 0.6875vw;
  font-weight: 200;
  cursor: pointer;
  font-family: Raleway;

  @media (max-width: 768px) {
    padding: 1.33vw 3vw;
    font-size: 1.83vw;
    border-radius: 1vw;
  }
`;

export const RightSection = styled.div`
  flex: 1;
  font-family: Raleway;
`;

export const SectionTitle = styled.h2`
  color: white;
  font-size: 1.6667vw;
  font-weight: 500;
  margin-bottom: 1.25vw;
  font-family: Raleway;

  @media (max-width: 768px) {
    font-size: 6vw;
    margin-bottom: 3.33vw;
  }
`;

export const IntroText = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875vw;
  line-height: 1.6;
  margin-bottom: 2.8125vw;
  font-family: Raleway;

  @media (max-width: 768px) {
    font-size: 2.33vw;
    margin-bottom: 7.5vw;
  }
`;

export const CtaButton = styled.div`
  margin-top: 3.125vw;
  text-align: right;
  font-family: Raleway;

  @media (max-width: 768px) {
    margin-top: 8.33vw;
    text-align: center;
  }
`;

export const DevisButton = styled.button`
  width: 316.03375244140625px;
  height: 83.3565444946289px;
  opacity: 1;
  border-top-left-radius: 40px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 40px;
  border-bottom-left-radius: 5px;
  background: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0.25) 100%);
  box-shadow: 
    0px 1.85px 3.15px 0px #18A7B906,
    0px 8.15px 6.52px 0px #18A7B90A,
    0px 20px 13px 0px #18A7B90D,
    0px 38.52px 25.48px 0px #18A7B90F,
    0px 10.81px 46.85px 0px #18A7B913;
  border: none;
  color: #000;
  font-size: 16px;
  font-weight: 200;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: Raleway;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 
      0px 3px 6px 0px #18A7B909,
      0px 12px 10px 0px #18A7B90C,
      0px 25px 18px 0px #18A7B90F,
      0px 45px 32px 0px #18A7B912,
      0px 75px 55px 0px #18A7B915;
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    width: 280px;
    height: 70px;
    font-size: 14px;
  }

  @media (max-width: 480px) {
    width: 250px;
    height: 60px;
    font-size: 13px;
  }
`;

export const ValueItem = styled.div`
  display: flex;
  gap: 1.25vw;
  margin-bottom: 2.5vw;
  align-items: center;
  background: #141463;
  backdrop-filter: blur(10px);
  border-radius: 1vw;
  padding: 1.5vw;
  border: 1px solid rgba(255, 255, 255, 0.05);
  font-family: Raleway;

  @media (max-width: 768px) {
    gap: 3.33vw;
    margin-bottom: 6.67vw;
    padding: 4vw;
    border-radius: 2.67vw;
  }
`;

export const ValueIcon = styled.div`
  width: 3.4375vw;
  height: 3.4375vw;
  border-radius: 0.75vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-image: url(${pop});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-family: Raleway;

  svg {
    width: 1.625vw;
    height: 1.625vw;
  }

  @media (max-width: 768px) {
    width: 9.17vw;
    height: 9.17vw;
    border-radius: 2vw;

    svg {
      width: 4.33vw;
      height: 4.33vw;
    }
  }
`;

export const ValueContent = styled.div`
  flex: 1;
  font-family: Raleway;
`;

export const ValueTitle = styled.h3`
  color: white;
  font-size: 1.1875vw;
  font-weight:200;
  margin-bottom: 0.625vw;
  font-family: Raleway;

  @media (max-width: 768px) {
    font-size: 3.17vw;
    margin-bottom: 1.67vw;
  }
`;

export const ValueDescription = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875vw;
  line-height: 1.6;
  font-family: Raleway;

  @media (max-width: 768px) {
    font-size: 2.33vw;
  }
`;